<template>
  <div id="contenedor-agregar-grupo-obra">
    <v-form v-model="formularioValido" ref="registrarCatalogoGrupoObra">
      <v-card>
        <v-card-title class="secondary--text">
          Agregar nuevo Grupo de Obra
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <custom-text-field
            label="Número de Grupo de Obra"
            v-model="catalogoGrupoObra.numero"
            :rules="[mixReglas.requerido]"
            required
          >
          </custom-text-field>
          <custom-text-field
            label="Descripción"
            v-model="catalogoGrupoObra.descripcion"
            :rules="[mixReglas.requerido]"
            required
          >
          </custom-text-field>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="gurdar"
            :disabled="!formularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Guardar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import CustomButton from '@/components/buttons/Button.vue';
import CustomTextField from '@/components/inputs/TextField.vue';
import mixCatalogoGrupoObra from './mixCatalogoGrupoObra';

export default {
  name: 'AgregarCatalogoGrupoObra',
  mixins: [mixCatalogoGrupoObra],
  components: {
    CustomButton,
    CustomTextField,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      catalogoGrupoObra: {
        numero: '',
        descripcion: '',
      },
    };
  },
  methods: {
    async gurdar() {
      await this.mixAgregarCatalogoGrupoObra().then(() => {
        this.cerrar();
      });
    },
    clearForm() {
      this.$refs.registrarCatalogoGrupoObra.reset();
      this.$refs.registrarCatalogoGrupoObra.resetValidation();
      this.catalogoGrupoObra = {
        numero: '',
        descripcion: '',
      };
    },
    cerrar() {
      this.clearForm();
      this.$emit('cerrar');
    },
  },
};
</script>

<style lang="scss">

</style>
